import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import backgroundImage from './bg.png';
import { utils } from '@ohif/core';
import { useAppConfig } from '@state';
import { Button } from 'antd';
const { apiService } = utils;

const Login: React.FC = () => {
  const [username, setUsername] = useState('web');
  const [password, setPassword] = useState('web');
  const [errorMessage, setErrorMessage] = useState(''); // 用于显示错误信息
  const [isLoading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [appConfig, setAppConfig] = useAppConfig();
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // 使用 FormData 构造请求参数
    const formData = new FormData();
    formData.append('username', username);
    formData.append('password', password);
    setLoading(true);

    try {
      const response = await apiService({
        uri: '/api/login',
        method: 'POST',
        data: formData, // 传递 FormData
        headers: {}, // FormData 不需要设置 Content-Type，浏览器会自动处理
      });
      // 处理服务器返回的响应
      if (response.Status === '0') {
        setLoading(false);
        const user = { username };
        sessionStorage.setItem('user', btoa(JSON.stringify({ user })));

        const tokenManager = (window as any).tokenManager;
        if (tokenManager && tokenManager.setToken) {
          tokenManager.setToken(response.Token, response.ExpiresUtc, response.RefreshToken);
        }
        // 提前计算默认的 thumbnailLocation
        const defaultThumbnailLocation = checkOrientation() === 'portrait' ? 'top' : 'right';
        // 获取 isUserSet 的值
        const isUserSet = localStorage.getItem('isUserSet');
        // 初始化 thumbnailLocation 为默认值
        let thumbnailLocation = defaultThumbnailLocation;

        // 如果 isUserSet 为 'true'
        if (isUserSet === 'true') {
          // 尝试从 localStorage 中获取 thumbnailLocation
          const storedThumbnailLocation = localStorage.getItem('thumbnailLocation');
          // 如果存储的值存在，则使用存储的值，否则使用默认值
          thumbnailLocation = storedThumbnailLocation || defaultThumbnailLocation;
        }

        // 将最终的 thumbnailLocation 存储到 localStorage 中
        localStorage.setItem('thumbnailLocation', thumbnailLocation);

        navigate('/worklist'); // 成功登录后跳转到工作列表页面
      } else if (response.Status === '1') {
        setLoading(false);
        setErrorMessage('用户不存在');
      } else if (response.Status === '2') {
        setLoading(false);
        setErrorMessage('密码错误');
      }
    } catch (error) {
      setLoading(false);
      console.error('登录请求失败:', error);
      setErrorMessage('登录失败，请稍后重试');
    }
  };

  const checkOrientation = () => {
    if (window.matchMedia('(orientation: portrait)').matches) {
      console.log('竖屏');
      return 'portrait';
    } else if (window.matchMedia('(orientation: landscape)').matches) {
      console.log('横屏');
      return 'landscape';
    }
  };

  return (
    <div
      className="main-page-box relative flex min-h-screen items-center justify-center"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="w-full max-w-xl p-8">
        <h1
          className="mb-6 text-center text-5xl font-bold"
          style={{ color: '#3cd5e3' }}
        >
          {appConfig.mainTitle}
        </h1>
        <div className="w-full max-w-xl rounded bg-white p-8 shadow-md">
          <h2 className="mb-8 text-center text-2xl font-bold text-gray-800">登录</h2>
          {errorMessage && <div className="mb-4 text-center text-red-500">{errorMessage}</div>}{' '}
          {/* 错误提示 */}
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label
                htmlFor="username"
                className="mb-2 block text-gray-700"
              >
                用户名:
              </label>
              <input
                type="text"
                id="username"
                value={username}
                onChange={e => setUsername(e.target.value)}
                className="w-full rounded-md border px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                placeholder="请输入用户名"
                autoComplete="username"
                required
              />
            </div>
            <div className="mb-6">
              <label
                htmlFor="password"
                className="mb-2 block text-gray-700"
              >
                密码:
              </label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                className="w-full rounded-md border px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                placeholder="请输入密码"
                autoComplete="current-password"
                required
              />
            </div>
            <Button
              htmlType="submit"
              loading={isLoading}
              size="large"
              style={{ backgroundColor: '#4299e1', color: '#fff' }}
              className="w-full rounded-md bg-blue-500 py-2 text-white transition duration-200 hover:bg-blue-600"
            >
              登录
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
